module.exports = __webpack_public_path__ + "img/tabbar-training-active.9c07dc7.svg";